import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { reqMainCmAction, reqMainPdAction } from '../../modules/hp/mainModule';

import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import CustomImg from '../common/image/CustomImg';
import HpPopUpContainer from './HpPopUpContainer';
// import "slick-carousel/slick/slick-theme.css";
import {isMobileOnly} from 'react-device-detect';
import { useHistory } from 'react-router-dom';

const mHeight = "280px";
// const mHeight = "98px"; // prev
const pHeight = "413px";
// const mPageMargin = "0 4vw";
const mPageMargin = "0";
const pPageMargin = "0 auto";
const HpMainBannerBlock = styled.div`

  position:relative;
  display: ${isMobileOnly?"block":"flex"};
  height: ${isMobileOnly?"unset":pHeight};
  //margin-left: 4vw;
  ${!isMobileOnly&&"max-width: 1176px"};
  margin: ${isMobileOnly?mPageMargin:pPageMargin};
  margin-top: ${isMobileOnly?'60px':'80px'};
  //width: 100%;
  text-align: center;
  
  .abspop {
    position:absolute;
    top:0;
    left:0;
    width: 1176px;
  }
  .main-slide-inner {
    ${!isMobileOnly&&`width:1176px; margin:0 auto`};
    }
        
  
  .slick-slider {
      ${isMobileOnly?`
        // width: 92vw;
        // margin: 0 4vw;
      `:`
        // width: 320px;
        width: 826px;
        height: ${pHeight};
      `};
      opacity: 0;
      visibility: hidden;
      animation: fadeOut ease-out 1s;
      //-webkit-transition: opacity 5s ease-in;
      &.slick-initialized {
      animation: fadeIn ease-in 1s;
      visibility: visible;
      opacity: 1;    
      }
      z-index:1;  
  }
  
 
  .slick-slider .slick-list { 
    ${isMobileOnly?`
         // height: 98px;
         //    height: 26.3vw;          
    `:`
            // border-radius: 4px;
            border-bottom-left-radius: 40px;
            // height: 98px;
            // height: 26.3vw;
          // width:96vw;
          // margin-left: -4vw;
          // padding-left: 4vw;
  `} }
  .slick-slide {margin:0;}
  .link {display:unset !important  } // to avoid gap between image and wrapper div  
  .slide-img {
    display: block;
    vertical-align: middle;
    cursor: pointer;
  ${isMobileOnly?`
        object-fit:cover;
        width:100%;
        // width: 92vw;
        // height: 26.3vw;
        // height: 96vw;
        // margin: 0 4vw;
        height:${mHeight};    
        // border-radius: 4px;
        // border-bottom-left-radius:40px;
    `:`
        margin:0 auto; 
        object-fit:cover;
        // width:1176px;
        // height:${pHeight};
        // width: 320px;
        width: 826px;
        height: 413px;
    `};
    
    &.dummy { display:block; 
              position:absolute; 
              z-index: 0;
              //left:0;
              //margin-right: auto; 
              top:0;
              //object-fit: cover;
              width:100%;
              // height: ${isMobileOnly?'96vw':'650px'};
              // width:  ${isMobileOnly?'100%':'1176px'};
              img {
              position:relative;
              margin-right: auto;
              object-fit: cover;
              //height: ${isMobileOnly?mHeight:pHeight};
              width:  ${isMobileOnly?'100%':'1176px'};
              
              }
              }
    
        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
    
  }
  //background: #fef7c8;
    .slick-arrow {
      position: absolute;
      top: 50%;
      width: 36px;
      height: 36px;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
      text-indent: -9999px;
      overflow: hidden;
      z-index: 1;
      
      &.slick-next { right: 10px; background: url('/assets/images/icon/slide_next-icon.png') center center/auto no-repeat;}
      &.slick-prev { left: 10px; background: url('/assets/images/icon/slide_prev-icon.png') center center/auto no-repeat;}          
    }
  
  .slick-dots-box {
      position: absolute;
      bottom: ${isMobileOnly?"10px":"50px"};
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
    .slick-dots {
      li {
          position: relative;
          float: left;
          width: ${(props)=>{
              // const unit = isMobileOnly?"px":"px";
              const unit = "px";
              // const base = isMobileOnly?92:1176
            const base = isMobileOnly?100:160
              return ((base)/props.cnt)+unit;            
          }}; //117px;
          height: 2px;
          background-color: #f2f1f1;
          cursor: pointer;          
         button {
             position: absolute;
             top: 0;
             left: 0;
             width: 0;
             height: 100%;
             background-color: #f2f1f1;
             text-indent: -9999px;
             overflow: hidden;      
         }
      }    
    }
    .slick-progress_bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 2px;
      background-color: rgba(51,51,51,0.5);
      color: rgba(255,255,255,0.7);
      
      transition: width 1s ease-in-out;
    }    
     .control-btn {
        position: absolute;
        bottom: -6px;
        right: -32px;
        width: 14px;
        height: 14px;
        background: url("/assets/images/icon/stop-icon.png") center center/auto no-repeat;
      }
     .control-btn.play {
        background: url("/assets/images/icon/play-icon.png") center center/auto no-repeat;
      }        
  }
`;

const MyQuotesBlock = styled.div`
  background: url("/assets/images/main/hp_myquotes_gw${isMobileOnly?"_mobile_0608":"_pc_0608"}.jpg") center center/cover no-repeat;;
  
  ${isMobileOnly?`
      margin-top: 40px;
      border-radius: 4px;
      display: block;
      // width:100vw;
      width: 92vw;
      margin-left: 4vw;
      // height: 280px;
      height: 23.6vw; 
      position:relative;
      .kkjuk-slogan {
          position:absolute; top: 15%; left: 10%; color: white; text-align: left;
          .main-slogan {
            font-size:20px;
            font-weight:bold;
            letter-spacing: -0.5px;
            .highlight {color:#fec844;}
          }
        
          .sub-slogan {
            margin-top:10px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: -0.3px;
          }
      }
      .btn-kkjuk {
        position:absolute; bottom: 7%; right: 4%;   
        padding: 11px 20px 10px;
        border-radius: 20px;
        background-color: #ffc742;
        font-size: 13px;
      }  
  `:`
      // border-bottom-left-radius: 40px;
      margin-left: 30px;
      margin-bottom: 40px;
      display: block;
      // width:826px;
      width: 320px;
      height: ${pHeight}; 
      position:relative;
      .kkjuk-slogan {
          position:absolute; top: 111px; left: 61px; color: white; text-align: left;
          .main-slogan {
            font-size:32px;
            font-weight:bold;
            letter-spacing: -0.8px;
            .highlight {color:#fec844;}
          }
        
          .sub-slogan {
            margin-top:10px;
            font-size: 15px;
            font-weight: normal;
            letter-spacing: -0.75px;
          }
      }
      .btn-kkjuk {
        position:absolute; bottom: 111px; left: 61px;   
        padding: 8px 35px;
        border-radius: 20px;
        background-color: #ffc742;
        font-size: 16px;
        letter-spacing: -0.8px;
      }    
  `};

`;

const HpMainBannerNew = () => {
  const dispatch = useDispatch();
  const [slideIndex, setSlideIndex] = useState(0);
  const [isPlay, setIsPlay] = useState(true);
  const slider = useRef();
  const actionButton = useRef();
  const progressBar = useRef();
  const [progressWidth, setWidth] = useState('0');
  const [loaded, setLoadState] = useState(false);
  const history = useHistory();

  const { mainCmItems } = useSelector(
    ({ loadingReducer, mainReducer }) => ({
      loading: loadingReducer['main/MAIN_CM'],
      mainCmItems: mainReducer.mainCmItems,
    })
  );

  useEffect(() => {
    dispatch(reqMainCmAction());
    mainCmItems.length&&updateProgressBarWidth(0,1)
  }, [dispatch])

  const playPause = ()=>{
    if(isPlay){
      slider.current.slickPause();
      actionButton.current.classList.add('play');
    } else {
      slider.current.slickPlay();
      actionButton.current.classList.remove('play');
    }
    setIsPlay(!isPlay)
  }

  //setting initial width for progress bar
  // setWidth((100/mainCmItems.length)+"%");

  const updateProgressBarWidth = (current,next)=>{
    // if(!slider.current)return;
    const slideCount = mainCmItems.length;
    const slideVal = 100 / slideCount;

    const barWidth = slideVal * (next + 1);
    setWidth(barWidth+'%');
    setSlideIndex(next)
  }

  const nextSlide = ()=>{
    slider.current.slickNext();
  }
  const prevSlide = () =>{
    slider.current.slickPrev();
  }
  progressWidth==="0"&&mainCmItems.length&&updateProgressBarWidth(-1,0);

  const IMG = (item1)=>{
    let item = item1?item1.item:null;
    // return(isMobileOnly?<img className="slide-img" alt={item.bnnr_title} src={item.bnnr_img_mo_url} style={{objectFit:"cover", width:"100vw", height:"300px"}}/>:
    //   <img alt={item.bnnr_title} src={item.bnnr_img_url} style={{margin:"0 auto", objectFit:"cover",width:"1176px",height:"650px",borderBottomLeftRadius:"40px"}} />);
    // return(item?<img className="slide-img" alt={item.bnnr_title} src={isMobileOnly?item.bnnr_img_mo_url:item.bnnr_img_url}/>:
    //     <img className="slide-img dummy" alt="이미지 로딩중..."
    //          src={isMobileOnly?"https://via.placeholder.com/500x300.png?text=https://www.odgagu.co.kr":
    //       "https://via.placeholder.com/1176x650.png?text=https://www.odgagu.co.kr"}/>
    //       )
    //background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
    // return(item&&<img className="slide-img" alt={item.bnnr_title} src={isMobileOnly?item.bnnr_img_mo_url:item.bnnr_img_url}/>
    return(item&&<div className="slide-img" style={{ display: "block", background:`url(${isMobileOnly? item.bnnr_img_mo_url : item.bnnr_img_url}) center center/cover no-repeat` }}/>
    )
  }
  const settings = {
    arrows: false,
    lazyLoad:true,
    dots: true,
    infinite: true,
    autoplay: isPlay,
    autoplaySpeed: 3000,
    // speed: isMobileOnly?1000:300,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    className: 'main-slide-inner',
    // variableWidth: true,
    // adaptiveHeight: true,
    // onLazyLoad: ()=>{setLoadState(true)},
    // onreadystatechange:()=>{console.log('loaded!!')},
    appendDots: dots=>(
      <div className="">
        <div className="slick-dots-box">
          <ul className="slick-dots" style={{ display: "block" }}>{dots}</ul>
          {!isMobileOnly&&<button ref={p=>actionButton.current = p} type="button" className="control-btn" onClick={playPause}/>}
          <div ref={p=>progressBar.current = p} className="slick-progress_bar" style={{width:progressWidth}}/>
        </div>
        {!isMobileOnly&&<div className="slick-arrow slick-prev" onClick={prevSlide}/>}
        {!isMobileOnly&&<div className="slick-arrow slick-next" onClick={nextSlide}/>}


      </div>
    ),
    beforeChange:(current,next)=>updateProgressBarWidth(current,next)

  };

  // if ((mainCmItems === null) || (mainCmItems === undefined) || !mainCmItems.length) {
  //   return(
  //     <HpMainBannerBlock >
  //       <img alt="메인배너 로딩중..." src="/assets/images/common/main-banner_202009.png"
  //                           style={isMobileOnly?{width:"100%",height:"300px",objctFit:"cover"}:{margin:"0 auto", objectFit:"cover",width:"1176px",height:"650px",borderBottomLeftRadius:"40px"}}/>
  //     </HpMainBannerBlock>)
  //   ;
  // }
  const handleClick = (url)=>{
    window.location.href = url;
  }

  const handleMyEs = () => {
    history.push("/estimate/step1");
  }

  if(!mainCmItems.length) return (<div/>);

  return (
    <HpMainBannerBlock cnt={mainCmItems.length} >
      <Slider ref={s=>slider.current = s} {...settings} >
        {mainCmItems&&mainCmItems.length&&mainCmItems.map((item,key) => {
          return(
            <a className="link" key={key} href={item.landing_url} style={{verticalAlign:"middle", display:"block"}}>
              <IMG key={item.id} item={item}/>
            </a>
          )
        })}
      </Slider>
      <MyQuotesBlock style={{display:"block", cursor:"pointer"}} onClick={handleMyEs}>
        {/*<div className="kkjuk-slogan">*/}
        {/*  <p className="main-slogan"><span className="highlight">끄-적임</span> 한번으로</p>*/}
        {/*  <p className="main-slogan">원하는 견적을 한번에!</p>*/}
        {/*  <p className="sub-slogan">가구가 쉬워지다, 어디가구</p>*/}
        {/*</div>*/}
        {/*<button className="btn-kkjuk" onClick={handleMyEs}>*/}
        {/*  끄-적으로 견적 알아보기*/}
        {/*</button>*/}
      </MyQuotesBlock>
      {!isMobileOnly&&<div className="abspop"><HpPopUpContainer /></div>}
    </HpMainBannerBlock>
  );
};

export default HpMainBannerNew;
